import { createAction } from 'redux-actions';

import types from './types';

const clearOrder = createAction(types.CLEAR_ORDER);
const setLoading = createAction(types.SET_LOADING);
const setOrder = createAction(types.SET_ORDER_DATA);
const repeatOrder = createAction(types.REPEAT_ORDER);

const _loadOrder = createAction(types.LOAD_ORDER);
const loadOrder = (code, isFull = false, isResendEGiftEmail = false, isOffline = false) =>
    _loadOrder({ code, isFull, isResendEGiftEmail, isOffline });

const _setDataType = createAction(types.SET_DATA_TYPE);
const setDataType = (code, isFull = false) => _setDataType({ code, isFull });

const _setEGiftCardEntryNumber = createAction(types.SET_EGIFT_CARD_ENTRY_NUMBER);
const setEGiftCardEntryNumber = entryNumber => _setEGiftCardEntryNumber({ entryNumber });

const setEGiftCardResendAttempts = createAction(types.SET_EGIFT_CARD_RESEND_ATTEMPTS);

const setCurrentErrorCode = createAction(types.SET_CURRENT_ERROR_CODE);
const resetErrorCode = createAction(types.RESET_ERROR_CODE);
const downloadInvoice = createAction(types.DOWNLOAD_INVOICE);
const trackOrder = createAction(types.TRACK_ORDER);

export default {
    loadOrder,
    clearOrder,
    setLoading,
    setOrder,
    setDataType,
    repeatOrder,
    setEGiftCardEntryNumber,
    setEGiftCardResendAttempts,
    setCurrentErrorCode,
    resetErrorCode,
    downloadInvoice,
    trackOrder,
};
